import copy       from 'copy-to-clipboard';
import * as React from 'react';

function useCopyClick() {
  const copyIdRef = React.useRef(null);

  const [isCopied, setCopied] = React.useState(false);

  const cleanCopyId = React.useCallback(() => {
    if (copyIdRef.current) {
      clearTimeout(copyIdRef.current);

      copyIdRef.current = null;
    }
  }, []);
  // Keep copy action up to date
  const onCopy      = React.useCallback((text) => {
    try {
      copy(text);

      setCopied(true);

      // Trigger tips update
      cleanCopyId();

      copyIdRef.current = setTimeout(() => {
        setCopied(false);
      }, 3e3);
    } catch (error) {
      throw error;
    }
  }, [cleanCopyId]);

  React.useEffect(() => {
    return cleanCopyId;
  }, [cleanCopyId]);

  return [isCopied, onCopy];
}

export default useCopyClick;
